var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showNewVersion
    ? _c(
        "header",
        {
          staticClass: "overview-header",
          attrs: { "data-bot": "overview__header" }
        },
        [
          _c(
            "div",
            { staticClass: "overview-header__backlink" },
            [
              _c("CompassBackForwardButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.back"),
                  link: "javascript:history.back();",
                  type: "secondary",
                  size: "small",
                  back: ""
                }
              }),
              _vm._v(" "),
              _c("OverviewNav", {
                staticClass: "flex-right",
                attrs: {
                  overviewhash: _vm.overviewhash,
                  identity: _vm.identity,
                  splitter: _vm.splitter,
                  "use-s-p-a-routing": true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "overview-header__title-and-info" }, [
            _c(
              "div",
              { staticClass: "overview-header__info" },
              [
                _c(
                  "EditText",
                  {
                    staticClass: "overview-header__title",
                    attrs: {
                      text: _vm.opportunity.name,
                      canEdit: _vm.permissions.can_edit,
                      loading: _vm.isLoadingTitle,
                      contentTypographyClass: "typographies-heading-h1"
                    },
                    on: { update: _vm.handleTitleUpdate }
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "overview-header__title-content typographies-heading-h1"
                      },
                      [
                        _c(
                          "span",
                          { attrs: { "data-bot": "overview__header--name" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.opportunity.name) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "overview-header__company-and-source" },
                  [
                    _c(
                      "div",
                      { staticClass: "overview-header__company" },
                      [
                        _c("CompassObject", { attrs: { size: "extra-small" } }),
                        _vm._v(" "),
                        _c("CompassLink", {
                          attrs: {
                            label: _vm.company.name,
                            link: _vm.company.link,
                            type: "secondary"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "overview-header__opportunity-id typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.opportunity.idName) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "overview-header__source typographies-paragraph-medium-regular"
                      },
                      [
                        _c("EditSelect", {
                          attrs: {
                            items: _vm.formattedSources,
                            canEdit: _vm.permissions.can_edit,
                            size: "small",
                            loading: _vm.isLoadingSource
                          },
                          on: { update: _vm.handleSourceUpdate }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "overview-header__pipeline typographies-paragraph-medium-semibold"
                      },
                      [
                        _c(
                          "CompassTooltip",
                          {
                            attrs: {
                              content: _vm.opportunity.funnelName,
                              arrow: false,
                              placement: "bottom-start"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.pipeName) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overview-header__data" },
              [
                _c(
                  "div",
                  { staticClass: "overview-header__status" },
                  [
                    _c(
                      "CompassFormItem",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.status"),
                          size: "small"
                        }
                      },
                      [
                        _c("EditSelect", {
                          attrs: {
                            items: _vm.statusesWithSelect,
                            canEdit: _vm.permissions.can_edit,
                            loading: _vm.isLoadingStatus,
                            showTag: true
                          },
                          on: { update: _vm.handleStatusUpdate }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasEndDate && _vm.hasEndDateValid
                  ? _c(
                      "div",
                      { staticClass: "overview-header__end" },
                      [
                        _c(
                          "CompassFormItem",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "common.labels.expected_close_date"
                              ),
                              size: "small"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "overview-header__end-date" },
                              [
                                _c("EditSimpleDate", {
                                  attrs: {
                                    date: _vm.endDate,
                                    loading: _vm.isLoadingDate,
                                    canEdit: _vm.canEditDate
                                  },
                                  on: { update: _vm.handleEndDateUpdate }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "overview-header__potential" },
                  [
                    _c(
                      "CompassFormItem",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.potential_amount"),
                          size: "small"
                        }
                      },
                      [
                        _c(
                          "EditText",
                          {
                            attrs: {
                              text: _vm.opportunity.potential,
                              canEdit: _vm.permissions.can_edit,
                              loading: _vm.isLoadingAmount,
                              numberFormat: _vm.numformat,
                              contentTypographyClass: "typographies-heading-h2"
                            },
                            on: { update: _vm.handlePotentialAmountUpdate }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "overview-header__potential-amount typographies-heading-h2"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm._f("numberformatCurrency")(
                                        _vm.opportunity.potential
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "CompassFormItem",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.one_or_more_staff"),
                      size: "small"
                    }
                  },
                  [
                    _c("EditMultipleUsers", {
                      attrs: {
                        data: _vm.sharedStaff,
                        loading: _vm.isLoadingStaff
                      },
                      on: { update: _vm.handleStaffUpdate }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "overview-header__pipeline-and-actions" },
            [
              _c("PipelineStepper", {
                attrs: {
                  pipeName: _vm.opportunity.funnelName,
                  steps: _vm.stepWithDate,
                  selectedStep: _vm.displayedStep,
                  canEdit: _vm.permissions.can_edit
                },
                on: {
                  update: function(step) {
                    return _vm.pickStep(step, true)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "overview-header__actions" },
                [
                  _c(
                    "CompassMenu",
                    {
                      attrs: {
                        placement: "bottom-end",
                        customClass: "overview-header__actions-menu"
                      }
                    },
                    [
                      _c("CompassIconButton", {
                        attrs: {
                          icon: "action",
                          "data-bot": "overview-header__actions-button"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: "dropdown" },
                        _vm._l(_vm.actionsWithAccess, function(action, index) {
                          return _c("CompassMenuItem", {
                            key: index,
                            attrs: {
                              disabled: !_vm.hasAccess(
                                action.permission,
                                _vm.permissions
                              ),
                              label: action.label
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleActionItemClick(action)
                              }
                            }
                          })
                        }),
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "CompassTooltip",
                    {
                      attrs: {
                        content: _vm.$t.__("common.labels.no_necessary_rights"),
                        disabled: _vm.hasAccess(
                          "can_create_invoicing_docs",
                          _vm.permissions
                        )
                      }
                    },
                    [
                      _c("CompassButton", {
                        attrs: {
                          type: "secondary",
                          label: _vm.$t.__("common.actions.create.document"),
                          disabled: !_vm.hasAccess(
                            "can_create_invoicing_docs",
                            _vm.permissions
                          ),
                          size: "small"
                        },
                        on: { click: _vm.createDocument }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "CompassMenu",
                    {
                      attrs: {
                        placement: "bottom-end",
                        customClass: "overview-header__schedule-menu"
                      }
                    },
                    [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.schedule"),
                          type: "secondary",
                          size: "small",
                          dropdown: ""
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: "dropdown" },
                        _vm._l(_vm.allowedScheduledActions, function(
                          action,
                          index
                        ) {
                          return _c(
                            "CompassMenuItem",
                            {
                              key: index,
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(action.type)
                                }
                              }
                            },
                            [
                              _c("CompassObject", {
                                attrs: {
                                  object: action.icon,
                                  size: "extra-small"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(action.label))])
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _c("header", { staticClass: "white-bkg bb-1 px-5 mt--5 ml--5 fs-3" }, [
        _c(
          "div",
          { staticClass: "flex-level flex-column ov-reset jc-space m-auto" },
          [
            _c("div", { staticClass: "flex-row px-4 pt-3 pb-2 pt-0" }, [
              _c("div", { staticClass: "w-3 no-shrink" }, [
                _c(
                  "div",
                  { staticClass: "relative" },
                  [
                    _c("person-list", {
                      attrs: {
                        list: _vm.opportunity.collab.list,
                        placeholder: _vm.opportunity.collab.placeholder
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "relative br my-2" },
                  [
                    _c("EditSelect", {
                      staticClass: "status-select",
                      attrs: {
                        items: _vm.statusesWithSelect,
                        canEdit: _vm.permissions.can_edit,
                        loading: _vm.isLoadingStatus,
                        showTag: true
                      },
                      on: { update: _vm.handleStatusUpdate }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "m-0 gray-60" }, [
                  _vm._v(_vm._s(_vm.opportunity.idName))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex-column flex acenter step-container ovx-hidden h-auto"
                },
                [
                  _c("h2", { staticClass: "mt-0 mb-1" }, [
                    _vm._v(_vm._s(_vm.opportunity.name))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0 gray-60" }, [
                    _vm._v(_vm._s(_vm.opportunity.funnelName))
                  ]),
                  _vm._v(" "),
                  _vm.hoverStep
                    ? _c(
                        "el-select",
                        {
                          staticClass:
                            "step-select wp-10 br b-1-bordercolor-hover mx-auto",
                          model: {
                            value: _vm.hoverStep,
                            callback: function($$v) {
                              _vm.hoverStep = $$v
                            },
                            expression: "hoverStep"
                          }
                        },
                        _vm._l(_vm.stepWithDate, function(step, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: step.name, value: step.id }
                          })
                        }),
                        1
                      )
                    : _c(
                        "el-select",
                        {
                          staticClass:
                            "step-select wp-10 br b-1-bordercolor-hover mx-auto",
                          on: { change: _vm.setStep },
                          model: {
                            value: _vm.selectedStep,
                            callback: function($$v) {
                              _vm.selectedStep = $$v
                            },
                            expression: "selectedStep"
                          }
                        },
                        _vm._l(_vm.stepWithDate, function(step, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { label: step.name, value: step.id }
                            },
                            [
                              _c("div", { staticClass: "flex-level" }, [
                                _vm.isBeforeSelectedStep(index)
                                  ? _c("span", { staticClass: "gray-60" }, [
                                      _vm._v(_vm._s(step.name))
                                    ])
                                  : _vm.selectedStep === step.id
                                  ? _c("span", { staticClass: "primary-50" }, [
                                      _vm._v(_vm._s(step.name))
                                    ])
                                  : _c("span", { staticClass: "gray-100" }, [
                                      _vm._v(_vm._s(step.name))
                                    ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "flex-right gray-60 ml-2" },
                                  [_vm._v(_vm._s(step.probability) + "%")]
                                )
                              ])
                            ]
                          )
                        }),
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "el-steps",
                    {
                      staticClass: "opp-step ov-hidden",
                      attrs: { active: _vm.displayedStep, "align-center": "" }
                    },
                    _vm._l(_vm.stepWithDate, function(step, index) {
                      return _c(
                        "el-step",
                        {
                          key: index,
                          class: { cpointer: _vm.permissions.can_edit },
                          nativeOn: {
                            mouseover: function($event) {
                              return _vm.stepHovered(step.id)
                            },
                            mouseleave: function($event) {
                              return _vm.stepHovered(null)
                            },
                            click: function($event) {
                              return _vm.pickStep(step)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "el-step__icon-inner",
                            attrs: { slot: "icon" },
                            slot: "icon"
                          })
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "w-3 no-shrink aright" }, [
                _c("h2", { staticClass: "mt-0 mb-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("numberformatCurrency")(_vm.opportunity.potential)
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.hasEndDate && _vm.hasEndDateValid
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.closeOppDatePicker,
                            expression: "closeOppDatePicker"
                          }
                        ],
                        staticClass: "dinlineb br mb-2 opp-date",
                        class: _vm.statusDateClass,
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openOppDatePicker($event)
                          }
                        }
                      },
                      [
                        _c("el-date-picker", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeDatePicker,
                              expression: "activeDatePicker"
                            }
                          ],
                          ref: "datepicker",
                          staticClass: "opp-date--picker",
                          attrs: {
                            "value-format": "yyyy-MM-dd",
                            type: "date",
                            format: _vm.dateFormatDisplay
                          },
                          model: {
                            value: _vm.endDate,
                            callback: function($$v) {
                              _vm.endDate = $$v
                            },
                            expression: "endDate"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.activeDatePicker,
                                expression: "!activeDatePicker"
                              }
                            ]
                          },
                          [
                            !_vm.activeDatePicker
                              ? _c("i", {
                                  staticClass: "mr-2",
                                  class: _vm.statusDateIcon
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.opportunity.endDate) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "m-0 gray-60" }, [
                  _vm._v(_vm._s(_vm.opportunity.source))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-row bt-1" }, [
              _c(
                "div",
                {
                  staticClass: "flex-row flex-level br-1 px-4 my-2",
                  class: _vm.isCorporation ? "flex-item-50" : "wp-10"
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t.__(
                              "overview.panels.OverviewPanel.deleted_company"
                            ),
                            placement: "top",
                            disabled: _vm.isThirdActive
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "black-link semibold mb-1 block",
                              attrs: {
                                href: _vm.isThirdActive
                                  ? _vm.company.link
                                  : null
                              }
                            },
                            [_vm._v(_vm._s(_vm.company.name))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "grey my-0" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.isCorporation
                                ? _vm.$l10n.__("Société")
                                : _vm.$l10n.__("Particulier")
                            ) +
                            "\n                    "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isThirdActive
                    ? _c("div", { staticClass: "flex-right aright" }, [
                        _c(
                          "span",
                          { staticClass: "copy-element block" },
                          [
                            _vm.companyPhone
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dinlineb mb-1 black-link",
                                    attrs: {
                                      href:
                                        _vm.phonecallProtocol +
                                        ":" +
                                        _vm.companyPhone.replace(/[^\+\d]/g, "")
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.companyPhone))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.companyPhone
                              ? _c("SaasClipboard", {
                                  attrs: { data: _vm.companyPhone }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "copy-element block" },
                          [
                            _vm.company.email
                              ? _c(
                                  "email-link",
                                  {
                                    staticClass: "dinlineb",
                                    attrs: {
                                      linkedtype: "third",
                                      linkedid: parseInt(_vm.company.id),
                                      disabled: _vm.company.isArchived
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.company.email) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.company.email
                              ? _c("SaasClipboard", {
                                  attrs: { data: _vm.company.email }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.isCorporation
                ? _c(
                    "div",
                    {
                      staticClass: "flex-row flex-level flex-item-50 pl-4 my-2"
                    },
                    [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "black-link semibold mb-1 block",
                            attrs: { href: _vm.mainContact.link }
                          },
                          [_vm._v(_vm._s(_vm.mainContact.fullName))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "grey my-0" }, [
                          _vm.mainContact.position
                            ? _c("span", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.mainContact.position) +
                                    "\n                        "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$l10n.__("Contact")) +
                                    "\n                        "
                                )
                              ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-right aright pr-4 br-1" },
                        [
                          _vm.mainContactPhone != ""
                            ? _c(
                                "span",
                                { staticClass: "copy-element block" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dinlineb mb-1 black-link",
                                      attrs: {
                                        href:
                                          _vm.phonecallProtocol +
                                          ":" +
                                          _vm.mainContactPhone.replace(
                                            /[^\+\d]/g,
                                            ""
                                          )
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.mainContactPhone))]
                                  ),
                                  _vm._v(" "),
                                  _vm.mainContactPhone
                                    ? _c("SaasClipboard", {
                                        attrs: { data: _vm.mainContactPhone }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mainContact.email
                            ? _c(
                                "span",
                                { staticClass: "copy-element block" },
                                [
                                  _c(
                                    "email-link",
                                    {
                                      staticClass: "dinlineb",
                                      attrs: {
                                        linkedtype: "opportunity",
                                        linkedid: parseInt(
                                          _vm.informations.identity.id
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.mainContact.email) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.mainContact.email
                                    ? _c("SaasClipboard", {
                                        attrs: { data: _vm.mainContact.email }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-4 self-center" },
                [
                  _c(
                    "el-dropdown",
                    [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.labels.actions"),
                          type: "secondary",
                          dropdown: ""
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        _vm._l(_vm.actionsWithAccess, function(action, index) {
                          return _c(
                            "el-dropdown-item",
                            {
                              key: index,
                              attrs: {
                                disabled: !_vm.hasAccess(
                                  action.permission,
                                  _vm.permissions
                                )
                              }
                            },
                            [
                              action.type == "function"
                                ? _c(
                                    "a",
                                    {
                                      class: !_vm.hasAccess(
                                        action.permission,
                                        _vm.permissions
                                      )
                                        ? "link-disabled"
                                        : "",
                                      on: {
                                        click: function($event) {
                                          return _vm.handleFunctionCall(
                                            action.value
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(action.label) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                : action.type == "vuejs"
                                ? _c(
                                    "a",
                                    {
                                      class: !_vm.hasAccess(
                                        action.permission,
                                        _vm.permissions
                                      )
                                        ? "link-disabled"
                                        : "",
                                      attrs: {
                                        onclick: _vm.buildUrl(
                                          action.value,
                                          _vm.parameters
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(action.label) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                : _c(
                                    "a",
                                    {
                                      class: !_vm.hasAccess(
                                        action.permission,
                                        _vm.permissions
                                      )
                                        ? "link-disabled"
                                        : "",
                                      attrs: {
                                        href: _vm.buildUrl(
                                          action.value,
                                          _vm.parameters
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(action.label) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }